/**
 * Keeps retail cart totals correct after BSS B2B scripts run.
 * Retail totals are rendered by cart-total-vivarium.liquid as a per-line
 * sum (taxable ×1.2; non-taxable bare) and stored on data attributes.
 * BSS targets [bss-b2b-cart-total-price]; retail uses [data-retail-inc-vat-total]
 * (and legacy [data-vivarium-cart-total]) instead.
 */
(function () {
  const TOTAL_SELECTOR = '[data-retail-inc-vat-total], [data-vivarium-cart-total]';

  function expectedHtml(el) {
    return el.dataset.retailTotalHtml || el.dataset.vivariumTotalHtml || '';
  }

  function restoreRetailCartTotals() {
    document.querySelectorAll(TOTAL_SELECTOR).forEach((el) => {
      const expected = expectedHtml(el);
      if (!expected) return;

      if (el.innerHTML.trim() !== expected.trim()) {
        el.innerHTML = expected;
      }
    });
  }

  function observeRetailCartTotals() {
    document.querySelectorAll(TOTAL_SELECTOR).forEach((el) => {
      if (el.__retailIncVatTotalObserver) return;

      const expected = expectedHtml(el);
      if (!expected) return;

      const observer = new MutationObserver(() => {
        if (el.innerHTML.trim() !== expected.trim()) {
          el.innerHTML = expected;
        }
      });

      observer.observe(el, { childList: true, characterData: true, subtree: true });
      el.__retailIncVatTotalObserver = observer;
    });
  }

  function init() {
    restoreRetailCartTotals();
    observeRetailCartTotals();

    [100, 500, 1500, 3000].forEach((ms) => {
      setTimeout(restoreRetailCartTotals, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      setTimeout(init, 100);
    });
  }
})();
